import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'dependentForm/progress';

export const DEPENDENT_FORM_PROGRESS_TYPES = {
  UPDATE_DEPENDENT: `${actionsScope}/update-dependent`,
  VALIDATE: `${actionsScope}/validate`,
  VALIDATE_FINISH: `${actionsScope}/validate-finish`,
  SET_ROLE: `${actionsScope}/set-role`,
  SET_STEP: `${actionsScope}/set-step`,
  SET_SUBMIT_REDIRECT: `${actionsScope}/set-submit-step`,
  GO_BACK: `${actionsScope}/back`,
  GO_NEXT: `${actionsScope}/next`,
  RESET: `${actionsScope}/reset`,
};

export const DEPENDENT_FORM_STEPS = {
  ROLE: 'ROLE',
  PERSONAL: 'personalInformation',
  GENERAL: 'generalInformation',
  DOCUMENTS: 'documentation',
  RELATION: 'relationship',
  COMPLETE: 'complete',
  USER_EXIST: 'userExist',
};

export const dependentFormActions = {
  updateDependent: createAction(DEPENDENT_FORM_PROGRESS_TYPES.UPDATE_DEPENDENT),
  validate: createAction(DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE),
  finishValidate: createAction(DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE_FINISH),
  setRole: createAction(DEPENDENT_FORM_PROGRESS_TYPES.SET_ROLE),
  setStep: createAction(DEPENDENT_FORM_PROGRESS_TYPES.SET_STEP),
  setSubmitRedirect: createAction(
    DEPENDENT_FORM_PROGRESS_TYPES.SET_SUBMIT_REDIRECT,
  ),
  goBack: createAction(DEPENDENT_FORM_PROGRESS_TYPES.GO_BACK),
  goNext: createAction(DEPENDENT_FORM_PROGRESS_TYPES.GO_NEXT),
  reset: createAction(DEPENDENT_FORM_PROGRESS_TYPES.RESET),
};



// WEBPACK FOOTER //
// ./src/redux/dependentForm/progress.actions.js